import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Box } from "@mui/system";
import React, { useContext, useEffect } from "react";
import { AuthContext } from "../providers/AuthContextProvider";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
var LoginScreen = function () {
    var t = useTranslation().t;
    var _a = useParams(), tenantId = _a.tenantId, eventId = _a.eventId;
    var navigate = useNavigate();
    var location = useLocation();
    var isAuthenticated = useContext(AuthContext).isAuthenticated;
    useEffect(function () {
        if (isAuthenticated) {
            navigate("/tenant/".concat(tenantId, "/event/").concat(eventId, "/election-chooser").concat(location.search));
        }
    }, [navigate, isAuthenticated, tenantId, eventId, location.search]);
    return (_jsx(Box, { className: "login-screen screen", children: _jsx(CircularProgress, { className: "login-progress", "aria-label": t("a11y.loading") }) }));
};
export default LoginScreen;
